import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d76cba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "users"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Users ", -1))
const _hoisted_3 = { class: "center-align" }
const _hoisted_4 = { class: "premium-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Premium:", -1))
const _hoisted_6 = { class: "premium-subcategories" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "vertical-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "Courses", -1))
const _hoisted_11 = { class: "chart" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart-title" }, "Results", -1))
const _hoisted_13 = { class: "chart" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleChoiceToggle = _resolveComponent("MultipleChoiceToggle")!
  const _component_HistogramChart = _resolveComponent("HistogramChart")!

  return (Object.keys(_ctx.users).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, "Guest: " + _toDisplayString(_ctx.guestCount), 1),
          _createElementVNode("p", null, "Registered: " + _toDisplayString(_ctx.registeredCount), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, "- permanent: " + _toDisplayString(_ctx.permanentPremiumCount), 1),
              _createElementVNode("p", null, "- active: " + _toDisplayString(_ctx.activePremiumCount), 1),
              _createElementVNode("p", null, "- expired: " + _toDisplayString(_ctx.expiredPremiumCount), 1)
            ])
          ]),
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("p", null, "Paid android: " + _toDisplayString(_ctx.paidAndroidCount), 1),
          _createElementVNode("p", null, "Difference since 3/5 2024: " + _toDisplayString(_ctx.paidAndroidCount + _ctx.permanentPremiumCount -  2081), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_MultipleChoiceToggle, {
            class: "usertype-toggle",
            options: _ctx.resourceLabels,
            onSelected: _ctx.onResourceGroupSelected
          }, null, 8, ["options", "onSelected"]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_HistogramChart, {
              ref: "coursesChart",
              tags: ['guest', 'registered', 'premium', 'expired premium', 'permanent premium', 'paid android']
            }, null, 512)
          ]),
          _hoisted_12,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.resourceGroup != 'downloaded')
                ? (_openBlock(), _createBlock(_component_HistogramChart, {
                    key: 0,
                    ref: "resultsChart",
                    tags: ['guest', 'registered', 'premium', 'expired premium', 'permanent premium', 'paid android']
                  }, null, 512))
                : (_openBlock(), _createElementBlock("p", _hoisted_14, " Not availible "))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _createTextVNode(" Loading... ")
      ]))
}